import React from 'react';
import Chip from '@mui/material/Chip';
import { navigate } from 'gatsby';

export type ChipLinkProps = {
  label: string,
  href: string,
};

const ChipLink = ({
  label,
  href,
}: ChipLinkProps) => (
  <Chip
    label={label}
    variant="outlined"
    onClick={() => navigate(href)}
  />
);

export default ChipLink;
